var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#pattern0_5219_17198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5219_17198",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5219_17198",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5219_17198",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPfSURBVHgB7Z29ThtBFIXvjlNREYka2aKhy4aShvACkHR0ieABkooWu6UiL4CgogVegKSANqRDSJYtaqS4ojPOnMmuZa8N/tvdO+ucTxqM7V2Q7jdzZ+ZuMYGMSaPRWGy32x+DINiwb0PbyrYtCgEt25q23XY6nZ+lUum8Uqm0xrkxGHWBDXz5+fn5q/31izDgk3BijKlZEc3XLnpRAHq8fTmwwf8mZGqshKqVUHvp+6ECol5/Jf/SDJmdphWxOWw0mOQHNvghg586rkPf39+HyS/6RgB7fuYMjIS+EcDgZ47r4NH86ugKqNfrB8Lg5wEkHMRvXAqKUk9DSG7YVFRBKnIjoNcIyQe7qXXL+wD5yAr4IyRvWhgFBuUFIRq40o6JajtEAVsz2sAcEApRwab+EALKQrQoQwArnHosGiGqUIAyFKAMBShDAcpQgDIUoAwFKEMBylCAMhSgDAUoQwHKUIAyFKAMBShDAcpQgDJvpABcX1/L2dmZPD09jXX98vKya2EYytramvhMUK/XO+I5+/v78vj4KNOwtLTk7serjxQiBU0b/PjearUqDw8P4iP/xRyA1HV4eDiTyKwoxByQ5Pj4+NXv7+7u3LyBFgMJuA/pyCfmcgSsrq7K3t6ebG9v930OMWg+MdcpCAIgo5ebmxvxibmfA7a2tvrecwTkDPYDvfg2Ec+9gIWFBfGZuReQTDnJEaHN3AvoXYoCCsiRi4uLAQGoD/lEITdir4ENF8oOl5eXA+kH9SDfinOFFLC7uyuTgsnYt10w8FIAUgdaWsTB97Ei6q2AtMBOGCPG13K0lwJQQphFAoKNwK+vrw+UInyjEA9kkjl/VDW0SPCZsDIUoIyXKSitVRDmkuQzAd/wcgSktQpKczWVFV4KSKvX+t77AVdBynASVqYQAnofqvi6o52WQgjY2dlxgYeIIuT1SSjEHDDPcA5QhgKUoQBlKEAZClCGApShAGUoQBkKUIYClKEAZShAGQpQhgKUoQBlKEAZClCGApSBgLEOHiaZ0IKAphAtmqbT6fwWosUtRsAPISrg/Pn4KEMc5MnTlHLGGPMWR3piEj4VkjcniL1bhloTR0Jyxca85l7xA+fa2nz0XUhe1OJjzbtnykdzwS/h0YZZ01xZWanEb7o7YZePjNkU7guypBnFuEtfKcIdsW3MJ6GELHCxjVNPTDDsyuiM+SthOkoL1/OTwQdDi3G4EHnKSqgJmQksbmzw3w8LPghG/QGMhna7XQ2C4LOQcWnZwJ+WSqWjlwIfM1JADFZJ0fnzH6zRd/YflIW755iW7aBYyt+ivGADfx5tcEfyFyH5ZfzhndlQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubIconRound);
export default __webpack_public_path__ + "static/media/rubIconRound.bbbdf1414bdb786193323ced4fa471f4.svg";
export { ForwardRef as ReactComponent };